<template>
  <div class="scrollable-element" ref="scrollable">
    <template v-for="(item,i) in freeQuestTypes">
      <div class="type_title ele_bold" :key="i">{{ item }}</div>
      <div v-for="(checkup,j) in filteredFreeCheckups(i)" :key='j + "" + i'
           @click="openQuestDetail(checkup.id,checkup.questCode,checkup.status)">
        <el-card class="box-card" body-style="{padding: '0px'}">
          <i class="ele_bold" :class=icons[checkup.id] />
          <span class="quest_name ele_bold">{{ parseQuestNameByCode()(checkup.questCode) }}</span>
          <span class="quest_time">{{ checkup.time }}</span>
        </el-card>
      </div>
    </template>
  </div>
</template>

<script>
import {parseQuestNameByCode} from "../assets/js/questIntro";
import HttpRequest from "../utils/request";
import {mapState} from "vuex";

export default {
  data() {
    return {
      icons: [
        'el-icon-s-operation',
        'el-icon-finished',
        'el-icon-place',
        'el-icon-brush',
        'el-icon-s-grid',
        'el-icon-s-finance',
        'el-icon-document',
        'el-icon-document-checked',
        'el-icon-notebook-2',
        'el-icon-office-building',
        'el-icon-finished',
        'el-icon-finished',
      ],
      freeQuestTypes: ['自我探索类','决策类','求职类','环境适应'],
      freeCheckups: new Map([
          ['holland', {id: 0,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'holland'}],
          ['holland56', {id: 0,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'holland56'}],
          ['mbti', {id: 1,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'mbti'}],
          ['mbti70', {id: 11,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'mbti70'}],
          ['occvalue', {id: 2,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'occvalue'}],
          ['disc', {id: 3,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'disc'}],
          ['ennea', {id: 4,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'ennea'}],
          ['bstyle', {id: 5,questId: null,typeCode: 0,status:10,type: 'free',checkupId: -1,time: null,questCode: 'bstyle'}],
          ['cddq', {id: 6,questId: null,typeCode: 1,status:10,type: 'free',checkupId: -1,time: null,questCode: 'cddq'}],
          ['decise', {id: 7,questId: null,typeCode: 1,status:10,type: 'free',checkupId: -1,time: null,questCode: 'decise'}],
          ['cvcheck', {id: 8,questId: null,typeCode: 2,status:10,type: 'free',checkupId: -1,time: null,questCode: 'cvcheck'}],
          ['univadapt', {id: 9,questId: null,typeCode: 3,status:10,type: 'free',checkupId: -1,time: null,questCode: 'univadapt'}],

          // ['ceshi', {id: 10,questId: null,typeCode: 3,status:10,type: 'free',checkupId: -1,time: null,questCode: 'ceshi'}]
      ])
    }
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    this.getFreeQuests()
  },
  mounted() {
    document.title = '测评中心';
  },
  methods: {
    parseQuestNameByCode() {
      return parseQuestNameByCode
    },
    //获取自由测评的测评时间
    getFreeQuests() {
      let url = "/constub/getFreeOrAssignQuests";
      let data = {token: this.student.token, type: 'free'};
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          let quests = res.data
          let freeCheckups = this.freeCheckups
          quests.forEach(item => {
            let freeCheckup = freeCheckups.get(item.questCode)
            freeCheckup.status = item.status
            freeCheckup.questId = item.questId
            freeCheckup.time = item.updateTime
            freeCheckup.checkupId = item.id
          })
          this.$forceUpdate()
        } else {
          this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
        }
      });
    },
    openQuestDetail(id,questCode,status) {
      // let data = {
      //   questCode: this.freeCheckups.get(questCode).questCode,
      //   checkupId: this.freeCheckups.get(questCode).id,
      //   type: this.freeCheckups.get(questCode).type,
      //   questId: this.freeCheckups.get(questCode).questId,
      //   time: this.freeCheckups.get(questCode).time
      // }
      // let path = ('/questIntro')
      this.$router.push({
         name: 'questIntro',
         params: {
           'questId': this.freeCheckups.get(questCode).questId,
            'checkupId': this.freeCheckups.get(questCode).checkupId,
            'questCode': this.freeCheckups.get(questCode).questCode,
            'type': this.freeCheckups.get(questCode).type,
            'time': this.freeCheckups.get(questCode).time,
            'status': status
         }
       });
    },
    filteredFreeCheckups(typeCode) {
      return Array.from(this.freeCheckups.values()).filter(value => value.typeCode === typeCode)
    }
  }

}
</script>

<style scoped>

i {
  font-size: 25px;
  margin-right: 10px;
}
.ele_bold {
  font-weight: bold;
}
.quest_time{
  float: right;
  padding-top: 8px;
}

.box-card{
  padding: 0 10px;
  margin: 13px 0;
}

</style>
